import Cookies from 'js-cookie'
var base = null
if (process.env.NODE_ENV === 'development') {
    base = 'https://apipqrepm.emtelco.co/'
    // base = 'https://esurveyexitobackend.emtelco.co/'
} else {
    base = 'https://apipqrepm.emtelco.co/' // Pruebas
    // base = 'https://esurveyexitobackend.emtelco.co/' // Producción
}
export default {
    api: base + 'api',
    year: '2019',
    email: base + 'email',
    change_password: base + 'change_password/',
    create_pqr: base + 'create_pqr/',
    download: base + 'download_attachment/',
    permissions: [],
    isLogin: false,
    hasPerm: function (permission) {
        var permissions = Cookies.getJSON('permissions')
        if (permissions.indexOf(permission) >= 0) {
            return true
        }
        return false
    },
    typePqrList: function () {
        return Cookies.getJSON('typePqrList')
    },
    statusPqrList: [
        {
            'value': 'CLOSED',
            'label': 'Cerrado'
        },
        {
            'value': 'SCALED',
            'label': 'Escalado'
        },
        {
            'value': 'PENDING',
            'label': 'Pendiente Verificación'
        }
    ],
    statusList: [
        {
            'value': false,
            'label': 'Inactivo'
        },
        {
            'value': true,
            'label': 'Activo'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/config/index.js